import styled from '@emotion/styled';

const SideContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 228px;
`;

export default SideContentContainer;
